{
  "alert_examples": {
    "camera_offline": "Камера Samarqand не работает 25 минут.",
    "cancelled_spike": "Развернувшихся у входа в 2 раза больше обычного.",
    "early_close": "Магазин закрылся на 15 минут раньше графика.",
    "flow_drop": "Riviera сегодня до 14:00 на 35% ниже среднего за 4 прошлых четверга.",
    "late_open": "City Mall сегодня открылся в 10:24 (обычно в 10:00).",
    "no_data": "С камеры Samarqand нет данных уже 30 минут.",
    "record": "Riviera: максимум посещений за 90 дней (318).",
    "target_progress": "Месячная цель выполнена на 82%, до конца месяца 5 дней."
  },
  "alert_kinds": {
    "agent_alert": "Предупреждение сервера",
    "camera_offline": "Камера офлайн",
    "cancelled_spike": "Рост развернувшихся у входа",
    "control_summary": "Контроль: сводка за час",
    "customer_unattended": "Покупатели без внимания",
    "store_no_staff": "В магазине нет сотрудников",
    "disk_pressure": "Диск заполняется",
    "early_close": "Раннее закрытие",
    "flow_drop": "Резкое падение потока",
    "late_open": "Позднее открытие",
    "long_wait": "Покупатель долго ждёт",
    "no_data": "Нет данных",
    "post_empty": "Пост пустой",
    "record": "Рекорд",
    "release_failed": "Не удалось применить настройки",
    "report_not_sent": "Отчёт не отправлен",
    "scheduled_task_failed": "Плановая задача не выполнена",
    "security": "Событие безопасности",
    "server_offline": "Сервер офлайн",
    "staff_gathering": "Сотрудники собрались вместе",
    "staff_phone": "Сотрудник в телефоне",
    "target_progress": "Цель"
  },
  "alert_severities": {
    "critical": "Критично",
    "info": "Информация",
    "warning": "Предупреждение"
  },
  "alerts": {
    "bell_label": "Уведомления: непрочитанных {{count}}",
    "channel_destination": "Куда: {{destination}}",
    "channel_telegram": "Telegram",
    "channel_unavailable_company_not_active": "Заработает после активации компании",
    "channel_unavailable_telegram_not_linked": "Telegram-группа компании ещё не подключена — обратитесь к администратору платформы",
    "description": "История уведомлений и какие из них отправлять в Telegram-группу",
    "empty": "Уведомлений нет",
    "empty_unread": "Непрочитанных уведомлений нет",
    "example_label": "Пример",
    "eyebrow": "УВЕДОМЛЕНИЯ",
    "filter_all": "Все",
    "filter_label": "Фильтр",
    "filter_unread": "Непрочитанные",
    "history_title": "История",
    "mark_all_read": "Отметить все как прочитанные",
    "mark_all_read_done": "Все уведомления отмечены как прочитанные",
    "mark_read": "Отметить как прочитанное",
    "open_store": "Открыть магазин",
    "preferences_saved": "Настройки сохранены",
    "preferences_title": "Отправка в Telegram-группу",
    "preferences_unavailable": "Нельзя настроить, пока группа не подключена",
    "preferences_unchanged": "Изменений нет — переключите что-нибудь, чтобы сохранить",
    "read_leave_list": "Прочитанные уведомления исчезают из списка через 24 часа",
    "rule": "Тип уведомления",
    "see_all": "Показать все",
    "unread": "Не прочитано"
  },
  "api_errors": {
    "breach_check_unavailable": "Сейчас не удаётся проверить пароль. Повторите попытку позже.",
    "captcha_required": "Пройдите проверку, чтобы продолжить.",
    "company_not_active": "Компания ещё не активирована. Панель откроется после того, как супер-администратор активирует компанию.",
    "conflict": "Данные изменились или уже существуют.",
    "csrf_failed": "Не удалось проверить запрос. Обновите страницу.",
    "export_failed": "Не удалось подготовить файл.",
    "export_not_ready": "Файл ещё не готов.",
    "forbidden": "Нет доступа к этому разделу или действию.",
    "hour_grain_too_long": "Почасовые данные доступны для периода до 62 дней. Выберите период короче.",
    "internal_error": "Внутренняя ошибка. Повторите попытку чуть позже.",
    "invalid_credentials": "Неверный логин или пароль.",
    "network_error": "Нет связи с сервером. Проверьте подключение.",
    "not_found": "Не найдено или нет доступа.",
    "password_breached": "Этот пароль есть в списке утёкших паролей. Выберите другой.",
    "password_change_required": "Смените пароль, чтобы продолжить.",
    "password_reset_code_invalid": "Код неверный или устарел. Запросите новый код.",
    "password_too_long": "Пароль слишком длинный.",
    "password_too_short": "Пароль должен содержать не менее 12 символов.",
    "pdf_renderer_unavailable": "PDF сейчас недоступен. Выберите Excel или CSV.",
    "rate_limited": "Слишком много попыток. Повторите попытку позже.",
    "session_expired": "Сессия истекла. Войдите снова.",
    "session_network_changed": "Сеть изменилась. В целях безопасности войдите снова.",
    "telegram_bot_unavailable": "Telegram-бот ещё не настроен. Обратитесь к администратору платформы.",
    "too_many_points": "Слишком много данных для выбранного периода. Выберите период короче или меньше магазинов.",
    "unauthenticated": "Войдите в систему снова.",
    "validation_failed": "Введённые данные неверны.",
    "wrong_old_password": "Текущий пароль неверен."
  },
  "blocks": {
    "average_day_description": "Средний день · {{range}}",
    "hourly_flow_metric": "Показатель почасового потока",
    "hourly_flow_title": "Почасовой поток",
    "hourly_period_too_long_text": "Например, выберите последние 30 дней",
    "hourly_period_too_long_title": "Почасовой поток — для периода до 62 дней",
    "hourly_series_unique": "Уникальные",
    "hourly_series_visits": "Все входы"
  },
  "brand": {
    "product_name": "Koz.uz"
  },
  "chart": {
    "axis_not_from_zero": "Ось начинается не с 0",
    "other": "Прочее"
  },
  "common": {
    "cancel": "Отмена",
    "copied": "Скопировано",
    "copy": "Копировать",
    "delete": "Удалить",
    "save": "Сохранить"
  },
  "comparison": {
    "best": "Лучший результат",
    "eyebrow": "СРАВНЕНИЕ ФИЛИАЛОВ",
    "metric": "Показатель",
    "metrics": {
      "cancelled": "Развернулись у входа",
      "children": "Дети",
      "returning_share": "Доля повторных, %",
      "unique": "Уникальные посетители",
      "visits": "Посещения (все входы)",
      "visits_per_hour": "Посещений в час",
      "work_hours": "Часы работы"
    },
    "missing_range": "Нет данных за {{range}}",
    "missing_short": "Нет данных для сравнения",
    "mode_label": "Режим сравнения",
    "mode_network": "Магазин и среднее по сети",
    "mode_stores": "Магазины",
    "network_average": "Среднее по сети",
    "network_index": "Среднее по сети принято за 100",
    "partial_day": "В периоде сравнения неполные данные (есть {{compare}} из {{current}} дн.)",
    "partial_hour": "В периоде сравнения неполные данные (есть {{compare}} из {{current}} ч)",
    "partial_store": "В день сравнения неполные данные (есть у {{compare}} из {{current}} магазинов)",
    "period_vs_period": "Текущий период и период сравнения",
    "pick_more_stores": "Выберите не менее {{count}} магазинов для сравнения",
    "title": "Сравнение магазинов",
    "view_indexed": "Индекс",
    "view_label": "Вид",
    "view_line": "Линии",
    "view_small_multiples": "Мини-графики",
    "view_table": "Таблица",
    "view_weekday": "Дни недели",
    "weekday_title": "{{metric}} · в среднем за день",
    "vs_range": "к {{range}}",
    "data_from_range": "{{range}} (данные с {{date}})",
    "point_no_data": "нет данных",
    "missing_days_legend": "{{range}} · нет данных за {{count}} дн.",
    "partial_coverage": "Данные неполные: в некоторые часы данных нет (полнота: текущий период {{current}}, период сравнения {{compare}})",
    "point_incomplete": "⚠ неполные данные",
    "part_incomplete": "Данные неполные: в некоторые часы этой части дня данных нет или был сбой"
  },
  "dashboard": {
    "daypart_afternoon": "День",
    "daypart_evening": "Вечер",
    "daypart_lunch": "Обед",
    "daypart_morning": "Утро",
    "dayparts_average_description": "По среднему дню · {{range}}",
    "dayparts_compare_label": "Сравнение",
    "dayparts_last_week": "Тот же день прошлой недели",
    "dayparts_title": "Части дня",
    "dayparts_yesterday": "Вчера",
    "description": "Живой поток и главные показатели ваших магазинов",
    "eyebrow": "ОБЗОР СЕТИ · {{date}}",
    "full_ranking": "Весь рейтинг",
    "insights_day": "Итоги вчерашнего дня · {{date}}",
    "no_region": "Без региона",
    "performance_title": "Эффективность филиалов",
    "ranking_title": "Рейтинг филиалов",
    "region_summary_unique": "{{stores}} магазинов · {{value}} уникальных посетителей",
    "region_summary_visits": "{{stores}} магазинов · {{value}} посещений",
    "store_tile_label_unique": "{{store}}: {{value}} уникальных посетителей, {{change}}",
    "store_tile_label_visits": "{{store}}: {{value}} посещений, {{change}}",
    "title": "Панель управления"
  },
  "doors": {
    "title": "Входы",
    "total_label": "Итого по магазину",
    "total_caption": "Входов: {{doors}}",
    "column_door": "Вход",
    "column_visits": "Посещения",
    "column_share": "Доля",
    "column_coverage": "Покрытие",
    "share_bar": "Доли входов",
    "state_partial": "Частично прервано",
    "state_none": "Нет данных",
    "partial_title": "Не работали входы: {{down}} из {{total}}",
    "none_title": "Ни один вход не считался",
    "outage_interval": "{{door}}: {{from}}–{{to}}",
    "outage_since": "{{door}}: с {{since}}",
    "note_interval": "не работал {{from}}–{{to}}",
    "note_since": "не работает с {{since}}",
    "note_more": "{{note}} · ещё {{count}}",
    "tile_partial": "Частично прервано: {{details}}",
    "tile_label_partial": "{{label}}, частично прервано"
  },
  "errors": {
    "go_home": "На главную",
    "not_found_text": "Ссылка устарела или нет доступа к этому разделу.",
    "not_found_title": "Страница не найдена",
    "save_failed": "Не удалось сохранить. Попробуйте ещё раз."
  },
  "exports": {
    "delete_after_ready": "Когда файл будет готов, его можно скачать или удалить",
    "delete_description": "«{{name}}» будет удалён из списка и с сервера. При необходимости отчёт можно сформировать заново.",
    "delete_failed": "Не удалось удалить файл. Попробуйте ещё раз.",
    "delete_named": "Удалить файл «{{name}}»",
    "delete_title": "Удалить файл?",
    "dismiss": "Убрать из списка",
    "download": "Скачать",
    "failed_hint": "Сформируйте отчёт ещё раз",
    "failed_title": "Экспорт не выполнен",
    "file_kept_until": "Файл хранится до {{time}} (удаляется после скачивания)",
    "jobs_description": "Файл удаляется после скачивания или через 24 часа",
    "jobs_title": "Экспорты",
    "kind_csv": "CSV (UTF-8)",
    "kind_pdf": "PDF",
    "kind_xlsx": "Excel (.xlsx)",
    "link_valid_until": "Ссылка действует до {{time}}",
    "list_failed": "Не удалось загрузить список экспортов",
    "no_jobs": "Экспортов пока нет",
    "no_jobs_hint": "Когда вы сформируете отчёт, файл появится здесь",
    "ready_title": "Файл готов",
    "report_control_events": "События контроля",
    "report_custom": "Произвольный отчёт",
    "report_daily": "Ежедневный отчёт",
    "report_monthly": "Ежемесячный отчёт",
    "report_screen": "Экспорт страницы",
    "report_weekly": "Еженедельный отчёт",
    "report_yearly": "Годовой отчёт",
    "started_title": "Экспорт запущен",
    "status_done": "Готово",
    "status_failed": "Ошибка",
    "status_queued": "В очереди",
    "status_running": "Готовится"
  },
  "filters": {
    "all_stores": "Все магазины",
    "stores": "Магазины"
  },
  "forgot_password": {
    "back_to_login": "Вернуться ко входу",
    "code": "6-значный код из Telegram",
    "code_sent": "Если Telegram подключён, код отправлен",
    "description": "Код придёт в ваш Telegram",
    "done_text": "Пароль сохранён, другие сеансы закрыты",
    "done_title": "Пароль изменён",
    "error_code_invalid": "Код неверный или устарел. Запросите новый код.",
    "go_to_login": "Войти",
    "no_telegram_hint": "Нет Telegram? Напишите администратору",
    "request_again": "Код не пришёл? Запросить снова",
    "save_password": "Сохранить новый пароль",
    "send_code": "Отправить код",
    "title": "Восстановление пароля"
  },
  "holidays": {
    "constitution_day": "День Конституции",
    "eid_al_adha": "Курбан хайит",
    "eid_al_fitr": "Рамазан хайит",
    "independence_day": "День независимости",
    "navruz": "Навруз",
    "new_year": "Новый год",
    "ramadan_start": "Начало Рамадана",
    "remembrance_day": "День памяти и почестей",
    "teachers_day": "День учителя",
    "womens_day": "Международный женский день"
  },
  "kpi": {
    "average_work_hours": "Среднее время работы",
    "busiest_hour": "Пиковый час",
    "busiest_hour_average_note_unique": "в среднем {{value}} уникальных посетителей",
    "busiest_hour_average_note_visits": "в среднем {{value}} посещений",
    "busiest_hour_compare": "{{range}}: {{hour}}",
    "busiest_hour_note_unique": "{{value}} уникальных посетителей",
    "busiest_hour_note_visits": "{{value}} посещений",
    "per_store_day": "на магазин в день"
  },
  "languages": {
    "en": "English",
    "ru": "Русский",
    "uz": "O'zbekcha"
  },
  "live": {
    "last_hour": "Посещения за последний час",
    "last_hour_unique": "Уникальные за последний час",
    "status_connecting": "подключение",
    "status_open": "подключено",
    "status_reconnecting": "переподключение",
    "title": "Онлайн-счётчик",
    "today_entries": "Посещения (онлайн)",
    "today_unique": "Уникальные (онлайн)",
    "updated_at": "Обновлено"
  },
  "login": {
    "error_invalid": "Неверный логин или пароль",
    "error_network": "Нет связи с сервером. Проверьте интернет.",
    "error_rate_limited": "Слишком много попыток. Повторите позже.",
    "forgot_link": "Забыли пароль?",
    "login": "Логин",
    "password": "Пароль",
    "submit": "Войти",
    "submitting": "Вход…",
    "subtitle": "Войдите в аккаунт вашей компании.",
    "title": "Вход в систему"
  },
  "metric_definitions": {
    "average_work_hours": "Сколько часов в среднем один магазин открыт за день.",
    "busiest_hour": "Час с наибольшим числом посещений за выбранный период.",
    "cancelled": "Вошли и вышли в течение 120 секунд (не входят в посещения).",
    "children": "Входы, распознанные как дети (не входят в посещения).",
    "coverage": "Какую часть торгового времени камеры работали. 100% — посчитано всё время.",
    "returning": "Посещения, распознанные как повторные в тот же день.",
    "staff": "Входы, распознанные как персонал.",
    "unique": "Главный показатель: сколько разных людей пришло за день. Человек, вернувшийся в тот же день, считается один раз.",
    "visits": "Сколько всего раз вошли в магазин: человек, вошедший дважды за день, считается дважды. Персонал, дети и сразу вышедшие не учитываются.",
    "visits_per_hour": "Сколько посещений в среднем приходится на каждый час работы магазина.",
    "work_hours": "Сколько времени магазин был открыт (по дверям или по графику)."
  },
  "metrics": {
    "cancelled": "Развернулись у входа",
    "children": "Дети",
    "coverage": "Полнота",
    "returning": "Повторные",
    "staff": "Проходы персонала",
    "unique": "Уникальные посетители",
    "visits": "Посещения (все входы)",
    "visits_per_hour": "Посещений в час",
    "work_hours": "Часы работы"
  },
  "months": {
    "apr": "Апр",
    "aug": "Авг",
    "dec": "Дек",
    "feb": "Фев",
    "jan": "Янв",
    "jul": "Июл",
    "jun": "Июн",
    "mar": "Мар",
    "may": "Май",
    "nov": "Ноя",
    "oct": "Окт",
    "sep": "Сен"
  },
  "nav": {
    "alerts": "Уведомления",
    "comparison": "Сравнение",
    "dashboard": "Панель управления",
    "group_account": "Аккаунт",
    "group_analytics": "Аналитика",
    "group_marketing": "Маркетинг",
    "group_operations": "Операции",
    "marketing_ads": "Реклама",
    "marketing_automation": "Автоматизация",
    "marketing_campaigns": "Кампании",
    "marketing_chats": "Чаты",
    "marketing_contacts": "Контакты",
    "marketing_connections": "Подключения",
    "marketing_content": "Контент",
    "marketing_overview": "Результат",
    "marketing_report": "Отчёт",
    "marketing_sales": "Продажи",
    "metrics": "Показатели",
    "quality": "Качество данных",
    "ranking": "Рейтинг",
    "reports": "Отчёты",
    "settings": "Настройки",
    "store_control": "Контроль магазина",
    "stores": "Магазины",
    "trading_hours": "Время работы",
    "trends": "Тренды"
  },
  "password": {
    "confirm": "Повторите новый пароль",
    "error_mismatch": "Пароли не совпадают",
    "error_password_breached": "Этот пароль есть в базе утёкших паролей",
    "error_password_reused": "Новый пароль должен отличаться от старого",
    "error_password_too_short": "Пароль слишком короткий",
    "error_unknown": "Не удалось изменить пароль",
    "error_wrong_old_password": "Текущий пароль неверен",
    "forced_text": "Замените временный пароль на свой",
    "forced_title": "Установите новый пароль",
    "new": "Новый пароль",
    "old": "Текущий пароль",
    "rules": "Не менее {{count}} символов, не с других сайтов",
    "save": "Сохранить пароль",
    "saving": "Сохранение…"
  },
  "quality": {
    "average_coverage": "Средняя полнота",
    "camera_offline": "офлайн",
    "camera_online": "онлайн",
    "coverage": "Полнота",
    "description": "Статус камер, перерывы и полнота по дням",
    "eyebrow": "СОСТОЯНИЕ УСТРОЙСТВ",
    "outage_kind_camera": "камера",
    "outage_kind_pipeline": "программа подсчёта",
    "outage_kind_system": "сервер",
    "outage_ongoing": "продолжается",
    "outage_summary": "{{count}} перерывов · {{minutes}} мин",
    "outage_summary_one": "{{count}} перерыв · {{minutes}} мин",
    "outage_summary_few": "{{count}} перерыва · {{minutes}} мин",
    "outage_summary_many": "{{count}} перерывов · {{minutes}} мин",
    "outages": "Перерывы",
    "title": "Качество данных",
    "outage_compact": "{{count}} шт · {{minutes}} мин",
    "outage_minutes": "{{minutes}} мин",
    "outage_burst": "перерывов: {{count}}",
    "outage_details": "Подробнее",
    "outage_total_minutes": "Общее время",
    "no_data": "Нет данных",
    "outage_count": "перерывов: {{count}}",
    "legend_good": "≥ 99%",
    "legend_warn": "95–99%",
    "legend_bad": "< 95%",
    "legend_empty": "Нет данных",
    "granularity": "Шаг",
    "granularity_day": "День",
    "granularity_week": "Неделя",
    "granularity_month": "Месяц",
    "outages_empty": "Перерывов нет",
    "page_summary": "{{from}}–{{to}} из {{total}}",
    "page_previous": "Предыдущая страница",
    "page_next": "Следующая страница",
    "summary_aria": "Кратко за период",
    "summary_coverage_hint_one": "по {{count}} магазину",
    "summary_coverage_hint_few": "по {{count}} магазинам",
    "summary_coverage_hint_many": "по {{count}} магазинам",
    "summary_coverage_hint_other": "по {{count}} магазинам",
    "coverage_info": "Полнота — какую долю времени работы магазина камеры и сервер были в строю. Перерыв — время, когда камера или сервер не работали: в эти минуты посетители не считаются, поэтому цифры за такой день могут быть ниже реальных. Перерывы короче минуты на цифры почти не влияют.",
    "summary_significant_days": "Важные дни",
    "summary_significant_hint_one": "в {{count}} магазине",
    "summary_significant_hint_few": "в {{count}} магазинах",
    "summary_significant_hint_many": "в {{count}} магазинах",
    "summary_significant_hint_other": "в {{count}} магазинах",
    "summary_long_outages": "Долгие перерывы",
    "summary_long_hint": "дольше 5 минут",
    "summary_lost_time": "Потерянное время",
    "summary_lost_hint": "пока магазин открыт",
    "summary_cameras": "Камеры онлайн",
    "summary_cameras_all_online": "Все работают",
    "summary_cameras_offline": "Офлайн: {{names}}",
    "significant_rule": "Только важные дни: полнота ниже 99,5% или перерыв дольше 5 минут",
    "show_minor": "Все перерывы (мелких: {{count}})",
    "sort": "Порядок",
    "sort_worst": "Сначала худшие",
    "sort_date": "По дате",
    "view": "Вид",
    "view_list": "Список",
    "view_calendar": "Календарь",
    "group_badge_days_one": "{{count}} день",
    "group_badge_days_few": "{{count}} дня",
    "group_badge_days_many": "{{count}} дней",
    "group_badge_days_other": "{{count}} дня",
    "group_summary_worst": "худший {{date}} · {{coverage}}",
    "group_summary_lost": "всего {{duration}}",
    "group_summary_long": "долгих: {{count}}",
    "group_summary_minor_only": "только мелкие перерывы",
    "duration_hours": "{{hours}} ч {{minutes}} мин",
    "no_significant": "За этот период важных перерывов не было",
    "no_significant_hint": "Скрыто дней с мелкими перерывами: {{count}}",
    "quiet_stores": "Без важных перерывов: {{stores}}",
    "minor_badge": "мелкий",
    "day_longest": "самый долгий {{minutes}}",
    "calendar_aria": "Календарь полноты",
    "calendar_full": "Полные (≥ 99,5%)",
    "calendar_significant": "Важный перерыв",
    "calendar_bad": "Полнота < 95%",
    "timeline_failed": "Шкала времени не загрузилась",
    "duration_whole_hours": "{{hours}} ч"
  },
  "ranking": {
    "change": "Изменение, %",
    "coverage": "Полнота",
    "eyebrow": "РЕЙТИНГ",
    "from": "Начало",
    "incomplete_badge": "⚠ неполные",
    "incomplete_description": "Магазины с полнотой ниже 95% показаны отдельно.",
    "incomplete_title": "Неполные данные",
    "index": "Индекс",
    "league_table": "Таблица рейтинга",
    "metric": "Показатель",
    "no_movers": "В этом периоде нет",
    "per_hour_hint": "Чтобы честно сравнить магазины с разными часами работы, выберите «Посещений в час»",
    "period": "Период",
    "periods": {
      "custom": "Произвольный",
      "day": "День",
      "month": "Месяц",
      "quarter": "Квартал",
      "week": "Неделя",
      "year": "Год"
    },
    "previous": "Прошлый период",
    "range_caption": "{{current}} · сравнение с {{previous}}",
    "rank": "Место",
    "rank_change": "Изменение",
    "store": "Магазин",
    "title": "Рейтинг магазинов",
    "to": "Конец",
    "top_drop": "Наибольшее падение",
    "top_growth": "Наибольший рост"
  },
  "reports": {
    "choose_month": "Выберите месяц",
    "choose_week": "Выберите неделю",
    "choose_year": "Выберите год",
    "custom_title": "Произвольный отчёт",
    "daily_range_too_long": "Не более {{days}} дней",
    "description": "Excel, CSV и PDF готовятся в фоне",
    "eyebrow": "ОТЧЁТЫ",
    "field_daily": "День или период",
    "field_monthly": "Месяц",
    "field_weekly": "Неделя",
    "field_yearly": "Год",
    "format": "Формат",
    "grain": "Детализация",
    "grain_day": "День",
    "grain_hour": "Час",
    "grain_month": "Месяц",
    "grain_week": "Неделя",
    "kind_daily": "Ежедневный",
    "kind_daily_contents": "По магазинам: показатели, часы работы, по часам",
    "kind_daily_schedule": "Автоматически: после торгового дня",
    "kind_monthly": "Ежемесячный",
    "kind_monthly_contents": "Дни, дни недели, рейтинг, прошлый год",
    "kind_monthly_schedule": "Автоматически: 1-го числа месяца",
    "kind_weekly": "Еженедельный",
    "kind_weekly_contents": "Дни, рейтинг, прошлая неделя и год",
    "kind_weekly_schedule": "Автоматически: понедельник 09:00",
    "kind_yearly": "Годовой",
    "kind_yearly_contents": "Месяцы, рейтинг, прошлый год, праздники",
    "kind_yearly_schedule": "По запросу",
    "metrics": "Показатели",
    "ready_title": "Готовые отчёты",
    "run": "Сформировать",
    "save_template": "Сохранить как шаблон",
    "template_all_stores": "Все магазины",
    "template_already_editing": "Этот шаблон уже открыт в форме выше",
    "template_cancel_edit": "Отмена",
    "template_delete_description": "Шаблон «{{name}}» будет удалён. Созданные по нему файлы останутся.",
    "template_delete_failed": "Не удалось удалить шаблон. Попробуйте ещё раз.",
    "template_delete_title": "Удалить шаблон?",
    "template_edit": "Изменить",
    "template_editing": "Редактируется шаблон «{{name}}»: внесите изменения и нажмите «Сохранить изменения»",
    "template_editing_badge": "Сейчас редактируется",
    "template_more_actions": "Другие действия для «{{name}}»",
    "template_name": "Название шаблона",
    "template_need_metric": "Выберите хотя бы один показатель",
    "template_need_name": "Чтобы сохранить, введите название шаблона",
    "template_no_permission": "Для сохранения шаблонов нужно право «Отчёты и уведомления». Обратитесь к администратору компании.",
    "template_rename": "Переименовать",
    "template_rename_description": "Введите новое название для «{{name}}»",
    "template_rename_title": "Переименовать шаблон",
    "template_save_changes": "Сохранить изменения",
    "template_save_failed": "Не удалось сохранить шаблон. Попробуйте ещё раз.",
    "template_store_count": "Магазинов: {{count}}",
    "templates_empty": "Шаблонов нет",
    "templates_empty_hint": "Выберите параметры выше, введите название и нажмите «Сохранить как шаблон»",
    "templates_title": "Сохранённые шаблоны",
    "title": "Отчёты и экспорт",
    "week_number_short": "Нед",
    "week_title": "{{week}}-я неделя, {{year}}"
  },
  "server_messages": {
    "alert": {
      "camera_offline": "{{store}}: камера {{camera}} не работает уже {{minutes}} мин.",
      "cancelled_spike": "{{store}}: у входа разворачиваются в {{ratio}} раза чаще обычного.",
      "control_summary": "{{store}}: {{total}} оповещений за {{hour_start}}–{{hour_end}} не отправлены отдельно — превышен часовой лимит.",
      "customer_unattended": "{{store}}, {{camera}}: покупатели ({{customer_count}}) без сотрудника с {{started_time}}, {{minutes}} мин.",
      "store_no_staff": "{{store}}: с {{started_time}}, {{minutes}} мин. ни на одной камере магазина не видно сотрудников.",
      "early_close": "{{store}} закрылся в {{closed_at}} (по плану {{planned_at}}).",
      "flow_drop": "{{store}}: посещений до {{until_hour}}:00 на {{drop_pct}} меньше среднего за последние {{weeks}} таких же дней недели.",
      "late_open": "{{store}} открылся в {{opened_at}} (обычно {{planned_at}}).",
      "long_wait": "{{store}}, {{camera}}: покупатель ждёт обслуживания с {{started_time}}, {{minutes}} мин.",
      "no_data": "{{store}}: нет данных уже {{minutes}} мин в рабочее время.",
      "post_empty": "{{store}}, {{camera}}: пост без сотрудника с {{started_time}}, {{minutes}} мин.",
      "record": "{{store}}: больше всего посещений за {{window_days}} дн. ({{visits}}).",
      "staff_gathering": "{{store}}, {{camera}}: {{staff_count}} сотрудников стоят вместе с {{started_time}}, {{minutes}} мин.",
      "staff_phone": "{{store}}, {{camera}}: сотрудник в телефоне с {{started_time}}, {{minutes}} мин.",
      "target_progress": "{{store}}: выполнено {{progress_pct}} месячной цели, до конца месяца {{days_left}} дн."
    },
    "insight": {
      "alert": {
        "title": "Внимание"
      },
      "leader": {
        "text": "{{store}}: {{unique}} уникальных посетителей ({{visits}} входов).",
        "title": "Лидер"
      },
      "network_change": {
        "text": "{{unique}} уникальных посетителей · {{change_pct}}",
        "title": "Сеть к прошлой неделе"
      },
      "weakest": {
        "text": "{{store}}: уникальные посетители {{change_pct}} к прошлой неделе.",
        "title": "Слабее всех"
      }
    }
  },
  "section_locked": {
    "title": "Раздел «{{section}}» вам недоступен",
    "title_generic": "Этот раздел вам недоступен",
    "reason_single_store": "Для сравнения и рейтинга нужно хотя бы два магазина, а вам назначен один.",
    "reason_company_admin_decides": "Какие разделы вам видны, решает администратор компании. При необходимости обратитесь к нему.",
    "reason_not_in_company_plan": "Этот раздел не подключён для вашей компании. Чтобы подключить, свяжитесь с Koz.uz.",
    "back": "Вернуться на главную"
  },
  "settings": {
    "api_key_created": "Создан",
    "api_key_last_used": "Последнее использование",
    "api_key_name": "Название",
    "api_key_name_required": "Чтобы создать, введите название ключа",
    "api_key_never_used": "Ещё не использовался",
    "api_key_prefix": "Ключ",
    "api_key_revoke": "Отозвать ключ {{name}}",
    "api_key_revoke_confirm": "Отозвать",
    "api_key_revoke_text": "Интеграции с этим ключом сразу перестанут работать.",
    "api_key_revoke_title": "Отзыв ключа",
    "api_key_revoked_toast": "Ключ отозван",
    "api_key_secret_text": "Ключ показывается только сейчас. Сохраните его в надёжном месте.",
    "api_key_secret_title": "Новый API-ключ",
    "api_key_stores_hint": "Если магазины не выбраны, ключ видит все магазины",
    "api_keys_description": "Для других программ (например, Power BI или Excel), которые сами забирают данные. Ключ только читает и видит только выбранные магазины.",
    "api_keys_title": "API-ключи",
    "appearance_description": "Сохраняется только в этом браузере",
    "appearance_title": "Язык",
    "branding_color": "Цвет компании",
    "branding_color_code": "Код цвета",
    "branding_color_description": "Цвет кнопок и акцентов",
    "branding_color_error_contrast": "Цвет слишком светлый — текст не читается. Выберите темнее.",
    "branding_color_error_format": "Введите в формате #RRGGBB.",
    "branding_color_hint": "Слишком светлый цвет выбрать нельзя: белый текст на кнопках должен читаться",
    "branding_color_reset": "Вернуть цвет платформы",
    "branding_color_save": "Сохранить цвет",
    "branding_color_saved": "Цвет сохранён",
    "branding_color_unchanged": "Цвет не изменён",
    "branding_description": "Логотип отображается в шапке панели, на вкладке браузера и в отчётах PDF/Excel.",
    "branding_logo_card_description": "Видно в шапке панели, на вкладке и в отчётах",
    "branding_logo_card_info": "После выбора файла изображение обрезается квадратом или кругом.",
    "branding_logo_error_file_too_large": "Файл больше 2 МБ.",
    "branding_logo_error_svg_not_allowed": "SVG не принимается — выберите PNG или JPG.",
    "branding_logo_error_unsupported_type": "Только файлы PNG или JPG.",
    "branding_logo_light": "Логотип компании",
    "branding_logo_light_hint": "Используется в светлой и тёмной теме",
    "branding_logo_none": "Логотипа нет — показывается логотип платформы",
    "branding_logo_remove": "Удалить",
    "branding_logo_removed": "Логотип удалён",
    "branding_logo_rules": "PNG или JPG, до 2 МБ",
    "branding_logo_saved": "Логотип сохранён",
    "branding_logo_title": "Логотип",
    "branding_logo_upload": "Загрузить логотип",
    "branding_read_only": "Логотип и цвет меняет администратор компании",
    "branding_shape_circle": "Форма: круг",
    "branding_shape_square": "Форма: квадрат",
    "branding_title": "Бренд компании",
    "create_api_key": "Создать ключ",
    "create_user": "Создать",
    "error_login_invalid": "Логин: только строчные латинские буквы, цифры и . _ - (не меньше 3)",
    "error_login_taken": "Логин занят",
    "eyebrow": "АККАУНТ",
    "initial_password_text": "Пароль для {{login}} показывается только сейчас. При первом входе его нужно сменить.",
    "initial_password_title": "Начальный пароль",
    "language_label": "Язык",
    "name_required": "Введите имя",
    "new_api_key": "Новый API-ключ",
    "new_password_title": "Новый пароль",
    "new_store_user": "Новый пользователь магазина",
    "no_api_keys": "Ключей нет",
    "no_store_users": "Пользователей нет",
    "password_changed": "Пароль изменён",
    "password_description": "Сессии на других устройствах завершатся",
    "password_save_needs": "Введите текущий пароль и дважды новый",
    "password_title": "Пароль",
    "profile_company": "Компания",
    "profile_description": "Ваше имя видно в панели и в истории изменений",
    "profile_login_hint": "Логин изменить нельзя",
    "profile_role": "Роль",
    "profile_saved": "Имя сохранено",
    "profile_scope_hint": "Роль и магазины назначает администратор",
    "profile_title": "Учётная запись",
    "profile_unchanged": "Имя не изменено",
    "role_company_admin": "Администратор компании",
    "role_store_user": "Пользователь магазина",
    "store_users_title": "Пользователи магазинов",
    "tab_api_keys": "API-ключи",
    "tab_preferences": "Вид",
    "tab_profile": "Профиль",
    "tab_security": "Безопасность",
    "tab_store_users": "Пользователи магазинов",
    "telegram_bot_unavailable": "Telegram-бот ещё не настроен — обратитесь к администратору",
    "telegram_connect": "Подключить Telegram",
    "telegram_connected": "Подключён",
    "telegram_connected_toast": "Telegram подключён",
    "telegram_description": "Сюда придёт код восстановления пароля",
    "telegram_disconnect": "Отключить",
    "telegram_disconnect_text": "После отключения коды восстановления пароля не будут приходить в Telegram.",
    "telegram_disconnect_title": "Отключить Telegram?",
    "telegram_disconnected_toast": "Telegram отключён",
    "telegram_linked_at": "с {{date}}",
    "telegram_loading": "Загрузка…",
    "telegram_not_connected": "Telegram пока не подключён",
    "telegram_open": "Открыть Telegram",
    "telegram_qr_label": "QR-код для открытия Telegram-бота",
    "telegram_step_open": "Отсканируйте QR-код или нажмите кнопку",
    "telegram_step_start": "Нажмите в боте кнопку «Start».",
    "telegram_title": "Telegram",
    "telegram_waiting": "Ждём подтверждения · {{minutes}} мин",
    "user_actions": "Действия",
    "user_actions_for": "{{login}}: действия",
    "user_active": "активен",
    "user_block": "Заблокировать",
    "user_block_text": "{{login}} не сможет войти в панель, открытые сессии сразу закроются. Позже можно разблокировать.",
    "user_block_title": "Заблокировать пользователя?",
    "user_blocked": "заблокирован",
    "user_blocked_toast": "Пользователь заблокирован",
    "user_create_needs": "Чтобы создать, введите логин и имя",
    "user_edit": "Изменить",
    "user_edit_description": "Логин: {{login}}. Логин изменить нельзя.",
    "user_edit_title": "Изменение пользователя",
    "user_last_login": "Последний вход",
    "user_login": "Логин",
    "user_login_hint": "3–64 символа: строчные латинские буквы, цифры, точка, _ или -",
    "user_name": "Имя",
    "user_never_signed_in": "Ещё не входил",
    "user_remove": "Удалить",
    "user_remove_text": "{{login}} исчезнет из списка и больше не сможет войти. Этот логин нельзя будет использовать снова.",
    "user_remove_title": "Удалить пользователя?",
    "user_removed_toast": "Пользователь удалён",
    "user_reset_confirm": "Выдать пароль",
    "user_reset_password": "Выдать новый пароль",
    "user_reset_text": "{{login}} больше не войдёт со старым паролем и выйдет на всех устройствах. Новый пароль покажем один раз.",
    "user_reset_title": "Выдать новый пароль?",
    "user_saved": "Изменения сохранены",
    "user_status": "Статус",
    "user_stores": "Магазины",
    "user_stores_hint": "Если магазины не выбраны, будет доступ ко всем",
    "user_unblock": "Разблокировать",
    "user_unblocked_toast": "Пользователь разблокирован"
  },
  "shell": {
    "company_eyebrow": "{{company}} · панель клиента"
  },
  "store": {
    "busiest_hours_title": "Самые активные часы",
    "calendar_title": "Календарь по дням",
    "composition_not_visits": "Не входят в посещения:",
    "composition_title": "Структура посещений",
    "description": "Посещения, часы работы и загруженные часы",
    "eyebrow": "МАГАЗИН · {{region}}",
    "eyebrow_plain": "МАГАЗИН",
    "hourly_table_title": "Почасовая таблица",
    "hourly_total": "Итого",
    "next_year": "Следующий год",
    "previous_year": "Предыдущий год",
    "switch_store": "Выбрать магазин",
    "trading_hours_door": "Открытие и закрытие измерены по жалюзи.",
    "trading_hours_manual": "Время работы по графику.",
    "trading_hours_title": "Время работы",
    "weekday_heatmap_title": "Дни недели и часы",
    "busiest_hour_mark": "пик"
  },
  "store_targets": {
    "title": "Планы на месяц",
    "description_editor": "План посещений на каждый месяц. Администратор платформы тоже видит и может менять эти планы.",
    "description_reader": "План посещений на каждый месяц. Планы задаёт администратор компании.",
    "list_label": "Список планов на месяц",
    "empty_title": "Планы ещё не заданы",
    "empty_editor_text": "Укажите месяц и число посещений ниже.",
    "empty_reader_text": "Планы задаёт администратор компании.",
    "load_failed": "Не удалось загрузить планы",
    "visits_value": "{{visits}} посещ.",
    "current_month": "Текущий месяц",
    "changed_by": "Изменил: {{who}}, {{when}}",
    "changed_at": "Изменено: {{when}}",
    "platform_editor": "{{name}} (администратор платформы)",
    "progress": "Сейчас {{done}} / {{target}} · {{percent}}",
    "progress_label": "Выполнение плана текущего месяца",
    "month": "Месяц",
    "visits": "План посещений",
    "visits_hint": "Целое число от 0 до 100 000 000",
    "save": "Сохранить",
    "update": "Обновить",
    "edit": "Изменить",
    "edit_month": "Изменить план на {{month}}",
    "delete": "Удалить",
    "delete_month": "Удалить план на {{month}}",
    "delete_title": "Удалить план",
    "delete_text": "План на {{month}} ({{visits}} посещений) будет удалён.",
    "saved": "План сохранён",
    "updated": "План обновлён",
    "deleted": "План удалён"
  },
  "table": {
    "date": "Дата",
    "hour": "Час",
    "store": "Магазин"
  },
  "trading_hours": {
    "actual_vs_plan": "{{actual}} (план {{plan}})",
    "average_close": "Среднее закрытие",
    "average_open": "Среднее открытие",
    "chart_off_plan": "Позднее открытие / раннее закрытие",
    "chart_plan": "График",
    "chart_range": "Открыт–закрыт",
    "closed": "Закрыт",
    "closed_today": "Закрыт сегодня",
    "day_incomplete": "неполные данные: закрытие не зафиксировано",
    "day_no_data": "нет данных",
    "day_still_open": "ещё не закрыт",
    "description": "Открытие, закрытие и отклонение от графика",
    "deviation": "Отклонение",
    "early_by": "закрыт на {{minutes}} мин раньше",
    "events_description": "Только магазины с камерой жалюзи",
    "events_title": "Позднее открытие / раннее закрытие",
    "eyebrow": "ВРЕМЯ РАБОТЫ",
    "hours": "Отработано",
    "late_by": "открыт на {{minutes}} мин позже",
    "late_days": "Дней с поздним открытием",
    "late_days_value": "{{late}} из {{total}} дн.",
    "no_events": "Опозданий в периоде нет",
    "no_off_hours": "В этом периоде нет",
    "not_opened_yet": "ещё не открыт",
    "off_hours_title": "Открытие в нерабочее время",
    "on_time": "вовремя",
    "opened": "Открыт",
    "opened_today": "Открыт сегодня",
    "per_schedule": "по графику",
    "plan": "График",
    "planned_close": "Плановое закрытие",
    "planned_open": "Плановое открытие",
    "source": "Источник",
    "source_door": "Жалюзи",
    "source_manual": "График",
    "source_planned": "По расписанию",
    "status": "Статус",
    "table_title": "Время работы по дням",
    "title": "Время работы",
    "tooltip_closed": "Закрыт {{time}}",
    "tooltip_open_for": "Открыт {{hours}} ч {{minutes}} мин",
    "tooltip_opened": "Открыт {{time}}",
    "tooltip_plan": "График {{range}}",
    "source_schedule_fallback": "Нет данных жалюзи — по графику",
    "source_shutter_missing": "Нет данных жалюзи",
    "not_measured": "по графику, не измерено",
    "not_measured_hint": "Камера жалюзи в это время не передавала данные, но покупатели входили: открытие и закрытие взяты из графика работы (не измерено).",
    "shutter_missing_hint": "Камера жалюзи не передавала данные, и графика работы нет: день посчитан без известной сессии.",
    "csv_not_measured_suffix": " (по графику, не измерено)",
    "tooltip_schedule_fallback": "Нет данных жалюзи — время по графику"
  },
  "trends": {
    "daily_title": "{{metric}}: по дням",
    "description": "Растёт ли число уникальных посетителей от недели к неделе",
    "eyebrow": "ТРЕНДЫ",
    "flag_recomputed": "Пересчитано",
    "flag_settings_change": "Изменены настройки",
    "metric": "Показатель",
    "moving_average": "Среднее за {{days}} дней",
    "promo_add": "Добавить акцию",
    "promo_after": "После",
    "promo_before": "До",
    "promo_daily_average_unique": "Среднее в день, уникальные",
    "promo_daily_average_visits": "Среднее в день, посещения",
    "promo_delete": "Удалить акцию {{name}}",
    "promo_delete_text": "Акция «{{name}}» будет удалена из календаря.",
    "promo_delete_title": "Удаление акции",
    "promo_during": "Во время акции",
    "promo_empty": "Акций пока нет",
    "promo_from": "Начало",
    "promo_list": "Список акций",
    "promo_name": "Название акции",
    "promo_not_yet": "ещё не наступил",
    "promo_title": "Акции",
    "promo_to": "Конец",
    "promo_vs_before": "К периоду до",
    "promo_window": "Период",
    "short_history_text": "Данные с {{date}}; тренды точнее после 2 месяцев",
    "short_history_title": "Данных пока мало",
    "title": "Тренды",
    "yoy_title": "По месяцам: текущий и прошлый год",
    "ytd_caption": "{{year}}: {{value}}",
    "ytd_note": "к тому же периоду прошлого года",
    "ytd_title": "{{metric}}: с начала года"
  },
  "user_menu": {
    "connections": "Подключения",
    "language": "Язык",
    "logout": "Выйти",
    "open": "Меню пользователя: {{name}}",
    "theme": "Тема",
    "theme_dark": "Тёмная",
    "theme_light": "Светлая",
    "theme_system": "Авто"
  },
  "weekdays": {
    "fri": "Пт",
    "mon": "Пн",
    "sat": "Сб",
    "sun": "Вс",
    "thu": "Чт",
    "tue": "Вт",
    "wed": "Ср"
  },
  "table_search": {
    "stores": "Поиск магазина…",
    "users": "Поиск пользователя…"
  },
  "control": {
    "compare": {
      "column_events": "События",
      "column_minutes": "Минуты",
      "column_rank": "Место",
      "column_region": "Регион",
      "column_store": "Магазин",
      "description": "Магазины и регионы относительно средней по сети",
      "group_regions": "Регионы",
      "group_stores": "Магазины",
      "grouping_label": "Группировка",
      "index": "Индекс",
      "index_definition": "Средняя по сети = 100. Ниже 100 — лучше",
      "metric_label": "Показатель",
      "metrics": {
        "per_1000_visits": "События на 1 000 посещений",
        "per_work_hour": "Минуты событий на рабочий час"
      },
      "network_average": "Средняя по сети",
      "no_region": "Без региона",
      "pick_more": "Выберите хотя бы 2 для сравнения",
      "ranking_title": "Рейтинг всех магазинов",
      "regions_label": "Регионы",
      "regions_placeholder": "Все регионы",
      "search_stores": "Поиск магазина…",
      "state_label": "Состояние"
    },
    "duration": {
      "hours_minutes": "{{hours}} ч {{minutes}} мин",
      "minutes": "{{minutes}} мин",
      "minutes_seconds": "{{minutes}} мин {{seconds}} с",
      "seconds": "{{seconds}} с"
    },
    "events": {
      "all_states": "Все состояния",
      "all_zones": "Все зоны",
      "description": "Каждое событие и его кадры",
      "empty": "По выбранным фильтрам событий нет",
      "export_excel": "Скачать Excel",
      "export_label": "События контроля · {{range}}",
      "false_positive_badge": "Отмечено как ошибка",
      "filter_states": "Состояния",
      "filter_zone": "Зона",
      "in_progress": "Продолжается",
      "list_title": "Список событий",
      "load_more": "Загрузить ещё",
      "open_event": "{{state}}, {{store}}, {{time}}",
      "staff_customers": "Сотр.: {{staff}} · Клиенты: {{customers}}",
      "total": "{{shown}} из {{total}}"
    },
    "eyebrow": "КОНТРОЛЬ МАГАЗИНА · {{date}}",
    "minutes": "{{value}} мин",
    "open_now_badge": "Открыто сейчас: {{count}}",
    "overview": {
      "all_events": "Все события",
      "description": "Дисциплина персонала и внимание к клиентам",
      "empty": "В выбранном периоде событий нет",
      "event_count": "{{formattedCount}} события",
      "event_count_few": "{{formattedCount}} события",
      "event_count_many": "{{formattedCount}} событий",
      "event_count_one": "{{formattedCount}} событие",
      "heatmap_title": "События по часам и дням",
      "mostly": "Чаще всего: {{state}}",
      "not_set_up": "Не настроено",
      "worst_title": "5 самых проблемных магазинов"
    },
    "score": {
      "details": "Подробнее",
      "formula": "Оценка = 100 × (1 − минуты событий ÷ наблюдаемые рабочие минуты). События, отмеченные как ошибка, не учитываются.",
      "grade_fair": "Средне",
      "grade_good": "Хорошо",
      "grade_poor": "Низко",
      "no_data": "Нет данных",
      "out_of": "/ 100",
      "title": "Оценка контроля"
    },
    "service": {
      "by_store_title": "По магазинам",
      "chart_title": "Время ожидания",
      "customers": "Наблюдаемые клиенты",
      "customers_definition": "Число клиентов в зонах обслуживания",
      "description": "Сколько клиент ждёт сотрудника",
      "long_wait_line": "Порог долгого ожидания",
      "median": "Обычное ожидание",
      "median_definition": "Половина клиентов ждала меньше (медиана)",
      "not_set_up": "Зоны обслуживания не настроены",
      "p90": "Долгое ожидание",
      "p90_definition": "90% клиентов ждали меньше (p90)",
      "unserved": "Ушли без обслуживания",
      "unserved_definition": "Доля клиентов, ушедших без контакта с сотрудником",
      "view_day": "День",
      "view_hour": "Час",
      "view_label": "Разрез",
      "view_weekday": "День недели"
    },
    "state_definitions": {
      "customer_unattended": "Клиенты есть, сотрудника рядом нет",
      "store_no_staff": "Ни на одной камере магазина не видно сотрудников. Все камеры проверяются вместе; пока какая-то камера недоступна, состояние не срабатывает.",
      "post_empty": "В зоне кассы или поста нет сотрудника",
      "service_wait": "Клиент долго ждал сотрудника",
      "staff_gathering": "3 и более сотрудников стоят вместе",
      "staff_phone": "Сотрудник долго смотрит в телефон"
    },
    "states": {
      "customer_unattended": "Клиент без внимания",
      "store_no_staff": "В магазине нет сотрудников",
      "post_empty": "Пост пуст",
      "service_wait": "Долгое ожидание",
      "staff_gathering": "Скопление сотрудников",
      "staff_phone": "Сотрудник в телефоне"
    },
    "store_block": {
      "by_zone": "По зонам (сегодня)",
      "details": "Подробнее",
      "none_open": "Сейчас открытых событий нет",
      "open_now": "Открыто сейчас",
      "started_ago": "{{minutes}} мин назад",
      "title": "Контроль",
      "today": "Сегодня",
      "zone_open": "{{count}} открыто"
    },
    "tabs": {
      "compare": "Сравнение",
      "events": "События",
      "overview": "Обзор",
      "service": "Качество обслуживания"
    },
    "tabs_label": "Разделы контроля магазина",
    "title": "Контроль магазина",
    "viewer": {
      "camera": "Камера",
      "confirm_action": "Да, ошибка",
      "confirm_text": "Событие будет исключено из всех показателей",
      "confirm_title": "Отметить событие как ошибку?",
      "duration": "Длительность",
      "ended": "Конец",
      "frame_alt": "{{state}}: кадр {{current}}, {{time}}",
      "frame_counter": "Кадр {{current}} из {{total}}",
      "frame_load_failed": "Кадр не загрузился",
      "frame_missing": "Кадр не найден",
      "frame_retry": "Повторить",
      "mark_failed": "Не удалось отметить",
      "mark_false": "Это ошибка",
      "marked": "Событие отмечено как ошибка",
      "marked_by": "Отметил как ошибку: {{user}}",
      "next_frame": "Следующий кадр",
      "no_frames": "Кадры этого события не сохранены",
      "no_media": "Нет доступа к кадрам",
      "people": "Люди",
      "previous_frame": "Предыдущий кадр",
      "started": "Начало",
      "store": "Магазин",
      "zone": "Зона",
      "cameras": "Камеры"
    },
    "time_span_open": "{{start}} – сейчас",
    "whole_store": "Весь магазин"
  },
  "grouped": {
    "legend": "Цвета",
    "period_presets": "Быстрый период",
    "preset_last_month": "Прошлый месяц",
    "preset_month": "Месяц",
    "preset_week": "Неделя",
    "show_more": "Показать ещё ({{left}})",
    "show_more_groups_few": "Ещё {{count}} магазина",
    "show_more_groups_many": "Ещё {{count}} магазинов",
    "show_more_groups_one": "Ещё {{count}} магазин",
    "show_more_groups_other": "Ещё {{count}} магазина"
  },
  "trading_hours_page": {
    "after_midnight_hint": "(+1) — после полуночи, на следующую календарную дату",
    "calendar_aria": "Календарь состояния дней",
    "card_average_close": "Среднее закрытие",
    "card_average_open": "Среднее открытие",
    "card_early_days": "Дни с ранним закрытием",
    "card_late_days": "Дни с поздним открытием",
    "card_measured_hint": "Только магазины с камерой на рольставне",
    "card_stores": "Магазины",
    "card_stores_hint": "рабочих дней: {{days}}",
    "closed_day": "не открывался",
    "column_average_close": "Ср. закрытие",
    "column_average_open": "Ср. открытие",
    "column_closed": "Закрылся",
    "column_date": "Дата",
    "column_deviation": "Отклонение",
    "column_early_days": "Рано закрылся",
    "column_hours": "Работал",
    "column_late_days": "Поздно открылся",
    "column_opened": "Открылся",
    "column_openings": "Открытия в нерабочее время",
    "column_plan": "План",
    "column_source": "Источник",
    "column_store": "Магазин",
    "column_total_hours": "Всего часов",
    "column_worked_days": "Рабочие дни",
    "daily_title": "Рабочее время по дням",
    "days_value": "{{count}} дн.",
    "deviation_value": "{{minutes}} мин",
    "download_csv": "Скачать (CSV)",
    "download_csv_hint": "Все дни периода, все магазины",
    "expand_store": "{{store}}: показать дни",
    "filter_all": "Все",
    "filter_label": "Что показать",
    "filter_longer": "Дольше",
    "filter_minutes_label": "Дольше скольких минут",
    "filter_minutes_option": "дольше {{minutes}} мин",
    "filter_night": "Только ночью",
    "kind_cleaning": "Уборка",
    "kind_night": "Ночное открытие",
    "latest": "последнее {{date}}",
    "minutes": "{{minutes}} мин",
    "next_page": "Далее",
    "no_rows": "За период нет данных",
    "openings_info": "Рольставня ненадолго (меньше 2 часов) открывалась, когда магазин закрыт: обычно уборка или приёмка товара. Открытия ночью (00:00–06:00) отмечены отдельно. Только магазины с камерой на рольставне.",
    "openings_list": "Открытия по магазинам",
    "openings_none": "За период магазины не открывались в нерабочее время",
    "openings_none_filtered": "Нет открытий по выбранному условию",
    "openings_summary": "Магазинов: {{stores}} · открытий: {{openings}} · самое долгое {{longest}}",
    "openings_title": "Открытия в нерабочее время",
    "page_status": "{{from}}–{{to}} из {{total}} магазинов",
    "per_schedule": "по графику",
    "previous_page": "Назад",
    "status_closed": "Не открывался",
    "status_late": "Поздно открылся / рано закрылся",
    "status_no_data": "Нет данных",
    "status_on_time": "Вовремя",
    "status_per_schedule": "По графику (нет камеры на рольставне)",
    "summary_aria": "Кратко за период",
    "times_few": "{{count}} раза",
    "times_many": "{{count}} раз",
    "times_one": "{{count}} раз",
    "times_other": "{{count}} раза",
    "total_hours_value": "{{hours}} ч",
    "view_calendar": "Календарь",
    "view_label": "Вид",
    "view_table": "По магазинам"
  },
  "marketing": {
    "billz": {
      "title": "Billz",
      "token": "Секретный токен Billz",
      "connect": "Подключить",
      "stores_hint": "Выберите магазин Billz для каждого магазина. Продажи читаются как итог за день.",
      "no_shop": "Не связан",
      "save": "Сохранить и загрузить",
      "disconnect": "Отключить",
      "disconnect_title": "Отключить Billz?",
      "disconnect_text": "Новые продажи не читаются. Прочитанные остаются.",
      "status_on": "Подключён",
      "status_stores": "Выберите магазин",
      "status_error": "Ошибка",
      "checking": "Проверяем…",
      "accepted": "Токен принят. В Billz найдено магазинов: {{count}}. Теперь сопоставьте магазины.",
      "no_shops": "Токен принят, но Billz не отдал список магазинов. Проверьте права токена.",
      "refused": "Billz не принял этот токен. Проверьте его и введите снова.",
      "running": "Принято, отчёты загружаются: {{percent}}%",
      "running_hint": "Готовы последние {{loaded}} дн., всего будет {{total}} дн. Загрузка продолжится, даже если закрыть окно; отчёты заполняются по ходу.",
      "running_start": "Читаем продажи за последние {{total}} дн. Загрузка продолжится, даже если закрыть окно.",
      "failed": "Загрузка остановилась на {{percent}}%",
      "failed_hint": "Billz не ответил. В следующий час загрузка сама продолжится с этого места.",
      "done": "Продажи за {{total}} дн. загружены",
      "save_first": "Выберите магазин",
      "close": "Закрыть"
    },
    "period_label": "Период",
    "money": "{{value}} сум",
    "pager": "{{first}}–{{last}} / {{total}}",
    "pager_previous": "Предыдущая страница",
    "pager_next": "Следующая страница",
    "errors": {
      "not_available": "Эта возможность ещё не готова.",
      "not_linked": "Этот аккаунт Instagram не подключён к сервису сообщений.",
      "bot_unavailable": "Не удалось связаться с сервисом сообщений. Повторите чуть позже.",
      "bot_error": "Сервис сообщений не выполнил запрос. Повторите чуть позже.",
      "center_unavailable": "Не удалось получить данные о визитах. Повторите чуть позже.",
      "reply_window_closed": "Окно ответа закрыто. Вы сможете ответить, когда клиент напишет снова.",
      "instagram_send_failed": "Instagram не принял сообщение. Попробуйте ещё раз.",
      "stop_failed": "Не удалось остановить автоматизации, поэтому аккаунт остался подключён. Повторите чуть позже.",
      "erase_failed": "Не удалось удалить данные, поэтому аккаунт остался подключён. Повторите чуть позже.",
      "shared_automations": "Некоторые автоматизации этого аккаунта отвечают и на другом аккаунте того же владельца. Выключите их в разделе автоматизации и повторите.",
      "shared_data": "Часть данных этого аккаунта общая с другим аккаунтом того же владельца. Чтобы удалить их, напишите на support@topkey.uz.",
      "connected_elsewhere": "Этот аккаунт подключён и к другой компании. Чтобы удалить его данные, напишите на support@topkey.uz."
    },
    "answer": {
      "estimate": "Оценка: без сравнения с другим магазином, на неё может влиять сезон.",
      "question": "Реклама принесла прибыль?",
      "no_spend": "Расход не указан, поэтому прибыль посчитана не полностью.",
      "profit": {
        "title": "Да, {{profit}} прибыли",
        "detail": "Дополнительные продажи {{sales}}, расход {{spend}}.",
        "action": "Кампании"
      },
      "loss": {
        "title": "Нет, {{profit}} убытка",
        "detail": "Дополнительные продажи {{sales}}, расход {{spend}}.",
        "action": "Кампании"
      },
      "need_margin": {
        "title": "Дополнительные продажи: {{sales}}",
        "detail": "Чтобы увидеть прибыль, укажите маржу.",
        "action": "Указать маржу"
      },
      "need_sales": {
        "title": "Визиты выросли: +{{visits}}",
        "detail": "Чтобы увидеть прибыль, загрузите продажи за дни кампании.",
        "action": "Загрузить продажи"
      },
      "unclear": {
        "title": "Пока неясно",
        "detail": "Дополнительных визитов от {{low}} до {{high}}: рост ещё не подтверждён.",
        "action": "Кампании"
      },
      "down": {
        "title": "Нет, визиты не выросли",
        "detail": "Магазины с рекламой отстали от контрольного.",
        "action": "Кампании"
      },
      "waiting": {
        "title": "Ждём результат",
        "detail": "После старта кампании посчитаем, сравнив с предыдущими днями.",
        "action": "Кампании"
      },
      "no_control": {
        "title": "Посчитать нельзя",
        "detail": "В кампании нет контрольного магазина. Выберите его в новой кампании.",
        "action": "Добавить кампанию"
      },
      "one_store": {
        "title": "Для результата пока мало данных",
        "detail": "Нужны посещения минимум за 2 недели до кампании. Посещения и продажи ниже.",
        "action": "Кампании"
      },
      "period_empty": {
        "title": "В этом периоде нет кампаний",
        "detail": "Выберите другой период или добавьте новую кампанию.",
        "action": "Кампании"
      }
    },
    "overview": {
      "title": "Результат",
      "full_report": "Все показатели",
      "spend": "Расходы на рекламу",
      "extra_visits": "Дополнительные визиты",
      "range": "Диапазон: {{low}} … {{high}}",
      "visit_cost": "Цена визита",
      "buyer_cost": "Цена покупателя",
      "chart_title": "Динамика по дням",
      "funnel_title": "От просмотра до покупки",
      "measured_spend": "С измеренным результатом: {{value}}",
      "paid_hint": "Укажите даты и расходы, и мы посчитаем, окупились ли деньги. Это необязательно.",
      "paid_action": "Добавить рекламу"
    },
    "verdict": {
      "up": "Визиты выросли",
      "down": "Визиты снизились",
      "unclear": "Не удалось определить"
    },
    "leak": {
      "content": {
        "title": "Контент или предложение не вызывают интереса",
        "action": "Попробуйте другое предложение и контент."
      },
      "reply": {
        "title": "Интерес есть, но люди не приходят",
        "action": "Отвечайте быстрее, добавьте адрес и промокод."
      },
      "store": {
        "title": "Визиты выросли, продажи нет",
        "action": "Проблема в магазине: проверьте продавцов, цены и ассортимент."
      },
      "margin": {
        "title": "Продажи выросли, прибыль нет",
        "action": "Пересмотрите скидку и бюджет рекламы."
      },
      "none": {
        "title": "Реклама приносит прибыль",
        "action": "Продолжайте и следите за возвратами клиентов."
      },
      "not_enough_data": {
        "title": "Недостаточно данных для вывода",
        "action": "Завершите шаги выше, и вывод появится."
      }
    },
    "factor": {
      "conversion": "Конверсия",
      "average_check": "Средний чек",
      "returning": "Вернувшиеся клиенты",
      "local_reach": "Местный охват",
      "reply": "Скорость ответа",
      "quiet_hours": "Тихие часы"
    },
    "campaigns": {
      "title": "Кампании",
      "new_title": "Новая кампания",
      "edit_title": "Изменить кампанию",
      "edit": "Изменить",
      "edit_named": "Изменить: {{name}}",
      "name": "Название",
      "offer": "Предложение",
      "stores": "Рекламируемые магазины",
      "control_stores": "Контрольный магазин",
      "control_hint": "Похожий магазин без рекламы. Разница покажет результат рекламы.",
      "single_store_hint": "Чтобы измерить прибыль, нужен второй магазин для сравнения.",
      "choose_stores": "Выберите магазин",
      "overlap_error": "Один магазин не может быть в обоих списках.",
      "from": "Начало",
      "to": "Конец",
      "dates_error": "Конец не может быть раньше начала.",
      "radius": "Радиус рекламы, км",
      "save": "Сохранить кампанию",
      "created": "Кампания сохранена",
      "status": "Статус",
      "period": "Период",
      "result": "Результат",
      "result_no_control": "Нет контрольного магазина",
      "result_not_started": "Ещё не началась",
      "result_waiting": "Ждём результат",
      "empty": "Кампаний пока нет",
      "empty_hint": "Прибыль считается через кампании.",
      "add": "Добавить кампанию",
      "delete": "Удалить",
      "delete_title": "Удалить кампанию?",
      "delete_description": "Кампания «{{name}}» будет удалена из списка.",
      "details": "Кампания",
      "spend": "Расход на рекламу, сум"
    },
    "campaign_status": {
      "planned": "Запланирована",
      "running": "Идёт",
      "finished": "Завершена"
    },
    "content": {
      "title": "Контент",
      "empty_title": "Instagram ещё не подключён",
      "syncing_title": "Instagram подключён, посты ещё не пришли",
      "syncing_hint": "Первая загрузка занимает несколько минут.",
      "refresh": "Обновить",
      "caption": "Контент",
      "kind": "Тип",
      "published": "Дата",
      "views": "Просмотры",
      "reach": "Охват",
      "saves": "Сохранения",
      "comments": "Комментарии",
      "direct_messages": "Сообщения",
      "view": "Вид",
      "view_grid": "Сетка",
      "view_table": "Таблица"
    },
    "content_kind": {
      "reel": "Reels",
      "post": "Пост",
      "story": "Сторис"
    },
    "ads": {
      "title": "Реклама",
      "not_ready_title": "Рекламный кабинет пока недоступен",
      "not_ready_hint": "Пока указывайте расход на рекламу в кампании.",
      "to_campaigns": "Перейти к кампаниям",
      "name": "Кампания",
      "status": "Статус",
      "spend": "Расход",
      "reach": "Охват",
      "clicks": "Клики",
      "local_reach": "Местный охват"
    },
    "ad_status": {
      "active": "Активна",
      "paused": "На паузе",
      "ended": "Завершена"
    },
    "automation": {
      "title": "Автоматизация",
      "empty_title": "Этот аккаунт не подключён к автоматизации",
      "name": "Автоматизация",
      "keywords": "Ключевые слова",
      "comments": "Комментарии",
      "direct_messages": "Отправлено сообщений",
      "saved": "Сохранено",
      "failed": "Ошибки",
      "match": "Совпадение",
      "match_contains": "Содержит",
      "match_exact": "Точно",
      "match_starts_with": "Начинается",
      "posts": "Посты",
      "all_posts": "Все посты",
      "message": "Текст сообщения",
      "followup": "Следующее сообщение",
      "delete": "Удалить",
      "save": "Сохранить",
      "delete_title": "Удалить автоматизацию?",
      "empty": "Автоматизаций пока нет",
      "new_title": "Новая автоматизация",
      "triggers": "Когда срабатывает",
      "trigger_comment": "Комментарий",
      "trigger_dm": "Сообщение",
      "trigger_story_reply": "Ответ на сторис",
      "trigger_story_mention": "Упоминание в сторис",
      "edit": "Изменить",
      "actions": "Действия: {{name}}",
      "not_found": "Автоматизация не найдена",
      "wizard": {
        "exit": "Выйти",
        "back": "Назад",
        "next": "Далее",
        "create": "Создать",
        "preview": "Просмотр",
        "step_of": "Шаг {{current}} из {{total}}",
        "step_trigger": "Когда срабатывает",
        "step_message": "Сообщение",
        "step_extras": "Дополнительно",
        "leave_title": "Выйти без сохранения?",
        "leave_text": "Изменения будут потеряны.",
        "leave_confirm": "Выйти",
        "templates_title": "Что должна делать?",
        "templates": {
          "comment_link": {
            "title": "Комментарий: сообщение со ссылкой",
            "description": "На комментарий приходит сообщение, подписчик получает ссылку.",
            "keywords": "ссылка|link",
            "message": "Здравствуйте! Подпишитесь на наш аккаунт и нажмите кнопку ниже, мы пришлём ссылку.",
            "button": "Я подписался",
            "followup": "Спасибо! Вот ссылка: https://",
            "replies": "Отправили в директ!|Проверьте директ|Ответили в сообщениях"
          },
          "price": {
            "title": "Ответ на вопрос о цене",
            "description": "Спросили цену, ответ приходит сразу.",
            "keywords": "цена|сколько|стоимость",
            "message": "Здравствуйте! Какой товар вас интересует? Пришлите фото, и мы скажем цену.",
            "replies": "Ответили в сообщениях|Проверьте директ"
          },
          "story": {
            "title": "Ответ на сторис",
            "description": "Отвечает тем, кто ответил на вашу сторис.",
            "keywords": "хочу|интересно",
            "message": "Спасибо за ответ! Если есть вопрос, напишите его здесь."
          },
          "blank": {
            "title": "Пустая",
            "description": "Начать с пустой формы."
          }
        },
        "trigger_text_comment": "Написали комментарий к посту или рилс",
        "trigger_text_dm": "Написали в директ",
        "trigger_text_story_reply": "Ответили на сторис",
        "trigger_text_story_mention": "Упомянули вас в сторис, ключевое слово не нужно",
        "posts_specific": "Выбранные посты",
        "posts_empty": "В этом аккаунте нет постов",
        "posts_selected": "Выбрано: {{count}}",
        "post_number": "Пост {{number}}",
        "keywords_hint": "После каждого слова нажмите Enter.",
        "keywords_placeholder": "цена",
        "message_placeholder": "Здравствуйте! Вот что вы просили...",
        "button_title": "Кнопка и следующее сообщение",
        "button_text": "По нажатию проверяется подписка, затем уходит следующее сообщение.",
        "button_text_mixed": "По нажатию проверяется подписка, затем уходит следующее сообщение. Работает только в ответе на комментарий.",
        "button_label": "Текст кнопки",
        "button_default": "Я подписался",
        "followup_placeholder": "Спасибо! Вот...",
        "replies_title": "Публичные ответы на комментарии",
        "replies_text": "На каждый комментарий выбирается случайный.",
        "replies_default": "Отправили в директ!|Проверьте директ|Ответили в сообщениях",
        "reply_number": "Ответ {{number}}",
        "reply_remove": "Удалить ответ {{number}}",
        "reply_add": "Добавить ответ",
        "reminder_title": "Своё напоминание о подписке",
        "reminder_text": "Уходит тому, кто нажал кнопку без подписки. Выключено: стандартный текст.",
        "reminder_label": "Текст напоминания",
        "reminder_default": "Сначала подпишитесь на наш аккаунт, затем нажмите кнопку ещё раз.",
        "active_title": "Включить сразу",
        "active_text": "Выключено: сохранится, но отвечать не будет, пока не включите.",
        "error_need_trigger": "Выберите хотя бы один вариант",
        "error_need_post": "Выберите хотя бы один пост",
        "error_need_keyword": "Добавьте ключевое слово",
        "error_need_message": "Напишите сообщение",
        "error_too_long": "Слишком длинный текст",
        "error_need_link": "Допишите ссылку после https://",
        "error_need_button": "Напишите текст кнопки",
        "error_need_followup": "Напишите следующее сообщение",
        "error_need_reply": "Напишите хотя бы один ответ",
        "error_need_reminder": "Напишите напоминание",
        "preview_tab_message": "Сообщение",
        "preview_tab_comment": "Комментарий",
        "preview_account": "ваш_аккаунт",
        "preview_user": "клиент",
        "preview_keyword": "ключевое слово",
        "preview_comment_note": "Ответ на ваш комментарий: {{keyword}}",
        "preview_story_reply": "Ответ на сторис",
        "preview_story_mention": "Упоминание в сторис",
        "preview_input": "Сообщение...",
        "preview_comments": "Комментарии",
        "preview_random": "Один из {{count}}, случайно"
      }
    },
    "sales": {
      "title": "Продажи",
      "format_hint": "В каждой строке: дата, название магазина, сумма продаж, число чеков. Откройте образец, заполните суммы и загрузите.",
      "file_hint": "Только файл CSV",
      "file_errors": "В файле ошибок: {{count}}, ничего не загружено:",
      "more_errors": "Ещё ошибок: {{count}}.",
      "store_names": "Названия в панели: {{names}}",
      "empty_file": "В файле нет строк продаж",
      "unreadable_file": "Не удалось прочитать файл. Проверьте, что это CSV.",
      "imported": "Загружено строк: {{count}}",
      "imported_dates": "Даты: {{from}} – {{to}}",
      "error": {
        "columns": "Строка {{line}}: нужно 4 столбца",
        "date": "Строка {{line}}: неверная дата ({{value}}). Образец: 2026-11-04",
        "store": "Строка {{line}}: магазин не найден ({{value}})",
        "revenue": "Строка {{line}}: сумма не указана или неверна ({{value}})",
        "receipts": "Строка {{line}}: число чеков не указано или неверно ({{value}})",
        "duplicate": "Строка {{line}}: этот день и магазин указаны дважды ({{value}})"
      },
      "margin": "Маржа, %",
      "margin_hint": "Сколько прибыли остаётся со 100 сум продаж.",
      "save": "Сохранить",
      "margin_saved": "Маржа сохранена",
      "date": "Дата",
      "store": "Магазин",
      "revenue": "Продажи",
      "receipts": "Чеки",
      "empty": "За этот период нет данных о продажах",
      "empty_hint": "Загрузите файл с продажами и чеками по дням.",
      "upload": "Загрузить",
      "upload_title": "Загрузка файла продаж",
      "sample": "Скачать образец файла",
      "total": "Всего продаж",
      "average_check": "Средний чек",
      "all_stores": "Все магазины",
      "margin_value": "Маржа: {{value}}%",
      "margin_empty": "Укажите маржу"
    },
    "connections": {
      "title": "Подключения",
      "connected": "Подключено",
      "not_connected": "Не подключено",
      "disconnect": "Отключить",
      "disconnect_title": "Отключить и остановить автоматизации?",
      "disconnect_instagram_description": "{{name}} и его публикации исчезнут из панели, а все его автоматизации перестанут отвечать. История переписок сохранится. При новом подключении они сами не включатся: вы включите их сами.",
      "disconnect_stop": "Отключить и остановить",
      "reconnect_needed": "Нужно подключить заново",
      "reconnect": "Подключить заново",
      "erase": "Удалить данные",
      "erase_title": "Удалить все данные этого аккаунта?",
      "erase_description": "Все сообщения, журналы, комментарии, автоматизации и токены {{name}} будут удалены из сервиса сообщений, а подключение и публикации — из этой панели. Это нельзя отменить.",
      "erase_confirm": "Удалить всё",
      "erased": "Данные аккаунта удалены",
      "automation_not_linked": "Автоматизация не подключена",
      "instagram": {
        "title": "Instagram"
      },
      "sales": {},
      "connect": "Подключить",
      "sales_label": "Продажи",
      "open": "Открыть",
      "return": {
        "connected": "Instagram подключён",
        "cancelled": "Подключение отменено",
        "expired": "Время истекло, попробуйте снова",
        "failed": "Не удалось подключить"
      },
      "sales_hint": "Billz или файл за день. Процент прибыли нужен для расчёта прибыли от платной рекламы.",
      "upload_file": "Загрузить файл"
    },
    "accounts": {
      "switch": "Аккаунт Instagram: {{name}}",
      "none": "Нет аккаунта",
      "connect_new": "Подключить новый аккаунт",
      "reconnect": "Подключить заново {{name}}"
    },
    "period_days": "{{count}} дн.",
    "seconds": "{{count}} сек.",
    "new": "Создать",
    "all": "Все",
    "metric": {
      "spend": "Расход",
      "visits": "Визиты",
      "sales": "Продажи"
    },
    "funnel": {
      "views": "Просмотры",
      "direct_messages": "Сообщения",
      "extra_visits": "Доп. визиты",
      "buyers": "Покупатели"
    },
    "money_million": "{{value}} млн сум",
    "chats": {
      "title": "Чаты",
      "search": "Поиск",
      "kind_conversations": "Диалоги",
      "kind_all": "Все",
      "empty": "Пока нет диалогов",
      "empty_all": "Пока никто не написал комментарий или сообщение",
      "empty_action": "Включить автоматизацию",
      "not_found": "Никого не найдено",
      "clear_search": "Очистить поиск",
      "load_more": "Показать ещё",
      "choose": "Выберите диалог",
      "back": "Назад",
      "unknown_person": "Пользователь Instagram",
      "no_messages": "Сообщений пока нет",
      "placeholder": "Напишите ответ",
      "send": "Отправить",
      "window_closed_title": "Сейчас ответить нельзя",
      "window_closed_hint": "Instagram разрешает ответ 24 часа после последнего сообщения. Вы сможете ответить, когда клиент напишет снова.",
      "comment_only_title": "Этот человек только комментировал",
      "comment_only_hint": "Instagram не разрешает писать первым. Вы сможете ответить, когда он напишет сообщение.",
      "open_instagram": "Открыть в Instagram",
      "delete_data": "Удалить данные этого человека",
      "delete_data_title": "Удалить данные этого человека?",
      "delete_data_description": "Его сообщения, комментарии и журналы на этом аккаунте, а также метки будут удалены. Это нельзя отменить. Если он снова напишет или оставит комментарий, новые сообщения будут записаны.",
      "delete_data_confirm": "Удалить",
      "delete_data_done": "Данные этого человека удалены",
      "comment": "Комментарий",
      "tags": "Теги",
      "not_linked": "Instagram ещё не подключён",
      "service_off_title": "Сервис сообщений ещё не включён",
      "service_off_hint": "Instagram подключён. Когда сервис включится, диалоги появятся здесь."
    },
    "contacts": {
      "title": "Контакты",
      "name": "Контакт",
      "total": "Всего: {{count}}",
      "comments": "Комментарии",
      "messages": "Сообщения",
      "last": "Последняя активность",
      "reply": "Ответ",
      "tags": "Теги",
      "empty": "Пока нет контактов",
      "can_reply": "Можно ответить"
    },
    "report": {
      "title": "Отчёт",
      "metric": "Показатель",
      "value": "Значение",
      "next": "Статус",
      "ready": "Готово",
      "cities": "Города магазинов",
      "metric_profit": "Доп. прибыль",
      "metric_cost_per_customer": "Цена покупателя",
      "metric_conversion": "Конверсия",
      "metric_returning": "Вернувшиеся клиенты",
      "metric_local_reach": "Местный охват",
      "metric_offer": "Лучшее предложение",
      "metric_reply_speed": "Скорость ответа",
      "metric_timing": "Тихие часы",
      "step_campaign": "Считается при платной рекламе",
      "step_control": "Выберите контрольный магазин",
      "step_one_store": "Нужно минимум 2 недели посещений",
      "step_sales": "Загрузите продажи",
      "step_margin": "Укажите маржу",
      "step_unconfirmed": "Рост не подтверждён",
      "step_cities": "Выберите город",
      "step_instagram": "Подключите Instagram",
      "step_automation": "Появится при включённой автоматизации",
      "step_visits": "Нет данных о посещениях"
    },
    "organic": {
      "question": "Что изменилось в магазине за период контента?",
      "no_history": {
        "title": "Для сравнения пока мало истории",
        "detail": "Нужны посещения или продажи минимум за 3 предыдущие недели. При подключении Billz продажи за 90 дней загрузятся сами."
      },
      "visits_up": "Посещения выросли: {{value}}",
      "visits_down": "Посещения снизились: {{value}}",
      "visits_unclear": "Явного изменения посещений нет",
      "sales_up": "Выручка выросла: {{value}}",
      "sales_down": "Выручка снизилась: {{value}}",
      "sales_unclear": "Явного изменения выручки нет",
      "detail": "Сравнение с предыдущими 4 неделями. За период постов: {{posts}}, просмотров: {{views}}.",
      "detail_no_posts": "Сравнение с предыдущими 4 неделями. Постов Instagram за период не видно.",
      "estimate": "Оценка: это сравнение во времени. На него могут влиять сезон и праздники.",
      "with_campaign_note": "В этот период была и платная реклама, изменение не только от контента.",
      "against_before": "{{value}} к предыдущим 4 неделям",
      "visits_total": "Посещения",
      "sales_total": "Выручка",
      "shares": "Репосты",
      "posts_title": "3 дня после каждого поста",
      "visits_after": "Посещения",
      "sales_after": "Выручка",
      "note": "Примечание",
      "with_post": "В те же дни, что другой пост",
      "with_campaign": "В те же дни, что реклама",
      "no_history_short": "Мало истории",
      "no_clear_change": "Неясно ({{value}})",
      "range": "Вероятный диапазон: {{low}} … {{high}}",
      "question_no_posts": "Что изменилось к предыдущим 4 неделям?"
    },
    "chain": {
      "seen": "Увидели",
      "came": "Зашли",
      "bought": "Купили",
      "paid": "Выручка",
      "seen_note": "Просмотры постов периода",
      "seen_empty": "Просмотры Reels и постов",
      "came_note": "По данным камеры",
      "came_empty": "Нет данных камеры",
      "sales_empty": "Через Billz или файл",
      "connect_instagram": "Подключить Instagram",
      "connect_sales": "Подключить продажи",
      "bought_note": "{{value}} от зашедших",
      "paid_note": "Средний чек {{value}}",
      "days": "За дней, где есть и камера, и продажи: {{count}}. Сегодня не учитывается.",
      "days_one_source": "За дней: {{count}}. Сегодня не учитывается.",
      "leak_title": "Главная потеря внутри магазина: {{lost}}% зашедших уходят без покупки.",
      "finding_none": "Явного отличия лучших дней от остальных пока не найдено.",
      "finding_sellers_together": "Разница в продавцах: за {{with_days}} дн., когда {{sellers}} работали вместе, купили {{with_percent}}% зашедших, за остальные {{other_days}} дн. {{other_percent}}%.",
      "finding_sellers_one": "Разница в продавце: за {{with_days}} дн., когда работал(а) {{sellers}}, купили {{with_percent}}% зашедших, за остальные {{other_days}} дн. {{other_percent}}%.",
      "finding_post": "Разница в контенте: в день поста и 2 дня после купили {{with_percent}}% зашедших ({{with_days}} дн.), в остальные {{other_days}} дн. {{other_percent}}%.",
      "finding_campaign": "Разница в рекламе: в дни рекламы купили {{with_percent}}% зашедших ({{with_days}} дн.), в остальные {{other_days}} дн. {{other_percent}}%.",
      "finding_factor": "В хорошие дни {{factor}}: {{good}}, в остальные: {{rest}}.",
      "observation": "Примерный расчёт по данным за дней: {{count}}, не обещание. На один чек может приходиться несколько человек. Обновляется по мере накопления данных.",
      "factor": {
        "returning_share": "доля вернувшихся клиентов (%)",
        "children_share": "доля детей (%)",
        "cancelled_share": "доля не вошедших (%)",
        "discounted_share": "доля чеков со скидкой (%)",
        "items_per_receipt": "штук в чеке"
      },
      "actions_title": "Что делать",
      "action_busy_hours": "В самые загруженные часы ({{hours}}) оставьте в зале самого сильного продавца: пусть первым подходит к каждому вошедшему.",
      "action_sellers_together": "Поставьте {{sellers}} в одну смену, особенно в самые загруженные часы ({{hours}}).",
      "action_sellers_one": "Поставьте {{sellers}} на самые загруженные часы ({{hours}}).",
      "action_goal": "Цель на 2 недели: поднять долю покупок с {{current}}% до {{target}}%. Это примерно +{{gain}} выручки в месяц.",
      "action_door": "В среднем {{people}} чел. в день разворачиваются у входа. Посмотрите вход и витрину: если они зайдут, это ещё примерно +{{gain}} выручки в месяц.",
      "seen_sample": "Instagram"
    }
  }
}
